module.exports = __webpack_public_path__ + "img/zf_icon04-2deb33.png";